import StockProductSearch from "./stockProductSearch.container";

export default StockProductSearch;
